import React from 'react';
import styled, { css } from 'styled-components';
import logos from './components';

export type Props = {
  name: keyof typeof logos;
  secondary?: boolean;
  color?: string;
  height?: string;
  width?: string;
  onClick?: () => void;
};

const Logo: React.FCC<Props> = ({
  dataTestId,
  name,
  secondary,
  color,
  width = '100%',
  height = width,
  ...rest
}) => {
  const PickedLogo = logos[name];

  return (
    <Container
      data-testid={dataTestId}
      {...rest}
      $height={height}
      $width={width}
    >
      <PickedLogo color={color || 'currentColor'} secondary={secondary} />
    </Container>
  );
};

const Container = styled.span<{ $height: string; $width: string }>(
  ({ $height, $width }) => css`
    svg {
      height: ${$height} !important;
      width: ${$width} !important;
    }
  `,
);

export default Logo;
